// import { DateTime } from "luxon";

// export const convertTimeZoneToString = (tz: string) => {
//   return `${tz.replaceAll("_", " ")} (GMT${DateTime.now().setZone(tz).toFormat("ZZ")})`;
// };

import { tzOffset } from "@date-fns/tz";

export const convertTimeZoneToString = (tz: string) => {
  const offsetMinutes = tzOffset(tz, new Date());

  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absOffset = Math.abs(offsetMinutes);
  const hours = Math.floor(absOffset / 60);
  const minutes = absOffset % 60;

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const gmtOffsetStr = `GMT${sign}${hh}:${mm}`;

  return `${tz.replaceAll("_", " ")} (${gmtOffsetStr})`;
};
